import React from 'react';

const NotFound = () => {
  return (
    <div style={{ padding: '5rem', textAlign: 'center' }}>
      <h1>404</h1>
      <p>Page not found.</p>
      <a href="/">Go to Home</a>
    </div>
  );
};

export default NotFound;
